var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import BackgroundAngledColor from './BackgroundAngledColor';
import { useWindowSize } from '../../hooks/useWindowSize';
var HeroText = function (props) {
    useEffect(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        // const tl = gsap.timeline({
        //   scrollTrigger: {
        //     trigger: '.longheroContainer',
        //     start: 'top center',
        //   },
        // });
        // tl.fromTo(
        //   ['.hero-text--title', '.hero-text--paragraph', '.hero-text--cta'],
        //   {
        //     opacity: 0,
        //     duration: 0,
        //     stagger: 0,
        //   },
        //   {
        //     opacity: 1,
        //     duration: 0,
        //     stagger: 0,
        //   },
        // );
    }, []);
    var width = useWindowSize()[0];
    var isMobile = useMemo(function () {
        return width < 1024;
    }, [width]);
    return (_jsx("div", __assign({ className: "relative" }, { children: _jsx(BackgroundAngledColor, { children: _jsx("section", __assign({ className: "w-full flex justify-center relative longheroContainer snap-start", id: "hero-text-long-hero-video" }, { children: _jsxs("span", __assign({ className: "block z-10 mx-auto relative long-hero-video-textWrapper" }, { children: [_jsx("h1", __assign({ className: "text-center text-white  mx-auto hero-text--title" }, { children: props.headlineText }), void 0),
                        _jsx("p", __assign({ className: "text-center text-white mx-auto hero-text--paragraph" }, { children: props.bodyText }), void 0),
                        _jsx("button", __assign({ className: "block mx-auto hero-text--cta" }, { children: _jsx("svg", __assign({ className: "stroke-current text-white", viewBox: "0 0 36 80", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M17.4677 0V78.2419M17.4677 78.2419L34.5 63.3387M17.4677 78.2419L1.5 63.3387", strokeWidth: "2.12903" }, void 0) }), void 0) }), void 0),
                        isMobile && (_jsx("img", { className: "hero-text--image", src: props.mobileImage, alt: "dispersed tiles" }, void 0))] }), void 0) }), void 0) }, void 0) }), void 0));
};
export default HeroText;
